import { graphql } from 'gatsby';

import { PossibleHeaderComponents } from './header-section';

export const HeaderDefaultFragment = graphql`
  fragment HeaderDefaultFragment on STRAPI__COMPONENT_COMPONENTS_HEADER_DEFAULT {
    strapi_component
  }
`;

export const componentName = 'components.header-default';

export type HeaderDefault = {
  strapi_component: typeof componentName;
};

export const isHeaderDefault = (
  component: PossibleHeaderComponents,
): component is HeaderDefault => {
  return component.strapi_component === componentName;
};
